<template>
  <base-section
    id="members"
  >
    <!---
    <base-section-heading title="Program Committee">
    </base-section-heading>
    --->
    <v-container>
      <base-title
        title="Steering Committee"
        size="text-h4"
        class="text-center"
      />
      <v-row>
        <v-col
          v-for="(member, i) in members"
          :key="i"
          cols="12"
          md="6"
        >
          <base-section
            space="0"
            style="text-align: left"
          >
            {{ member.title }} - <i>{{ member.text }}</i>
          </base-section>
        </v-col>
      </v-row>
      <br>
      <br>
        <v-footer
          id="program-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in committeesfooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < committeesfooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'Members',
    data: () => ({
      isMobile: false,
      committeesfooter: [
        {
          name: 'Program Chair',
          url: 'program-committee',
        },
        {
          name: 'Topic Chairs',
          url: 'topic-chairs',
        },
        {
          name: 'Program Committee Members',
          url: 'members',
        },
        {
          name: 'Program Committee Companions',
          url: 'companions',
        },
        {
          name: 'Steering Committee',
          url: 'companions',
        },
        {
          name: 'Industrial Board',
          url: 'industrial',
        },
        {
          name: 'Organizing Committee',
          url: 'organizing-committee',
        },
      ],
      members: [
       {
title: "Lorena Anghel",
text: "TIMA, FR",
},
{
title: "Paolo Bernardi",
text: "Politecnico di Torino, IT",
},
{
title: "Giorgio Di Natale",
text: "TIMA, FR",
},
{
title: "Stephan Eggersglüß",
text: "Siemens, DE",
},
{
title: "Georges Gielen",
text: "Katholieke Universiteit (KU) Leuven, BE",
},
{
title: "Said Hamdioui",
text: "Delft University, NL",
},
{
title: "Pete Harrod",
text: "ARM, UK",
},
{
title: "Sybille Hellebrand",
text: "Paderborn University, DE",
},
{
title: "Artur Jutman",
text: "Testonica, EE",
},
{
title: "Salvador Manich",
text: "University of Barcellona, ES",
},
{
title: "Erik Jan Marinissen",
text: "IMEC, BE",
},
{
title: "Maria K. Michael",
text: "University of Cyprus, CY",
},
{
title: "Liviu Miclea",
text: "Cluj Napoca University, RO",
},
{
title: "Zebo Peng",
text: "Linkoping University, SE",
},
{
title: "Rosa Rodríguez",
text: "University of Barcellona, ES",
},
{
title: "Matthias Sauer",
text: "University of Freiburg, DE",
},
{
title: "Matteo Sonza Reorda",
text: "Politecnico di Torino, IT",
},
{
title: "Haralampos Stratigopoulos",
text: "Sorbonne University, FR",
},
{
title: "Michele Stucchi",
text: "IMEC, BE",
},
{
title: "Mottaqiallah Taouil",
text: "Delft Universitym, NL",
},
{
title: "Daniel Tille",
text: "Infineon, DE",
},
{
title: "Elena-Ioana Vătăjelu",
text: "TIMA, FR",
},
{
title: "Hans-Joachim Wunderlich",
text: "ITI Stuttgart, DE",
},
{
title: "Yervant Zorian",
text: "Synopsys, US",
},
{
title: "Rolf Drechsler",
text: "Bremen University, DE",
},
      ],
      mounted () {
        this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
      methods: {
        isMobileDevice () {
          return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
        },
      },
    }),
  }
</script>
